import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/shared/patente_chile.svg")